import script from "./TrainingCalendar.vue?vue&type=script&setup=true&lang=js"
export * from "./TrainingCalendar.vue?vue&type=script&setup=true&lang=js"

import "./TrainingCalendar.vue?vue&type=style&index=0&id=0d5609d6&scoped=true&lang=css"
import "./TrainingCalendar.vue?vue&type=style&index=1&id=0d5609d6&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d5609d6"]])

export default __exports__